import React from 'react';
import PropTypes from 'prop-types';
import { round } from 'lodash';
import { Score } from '@src/components/Score';
import './styles.scss';

const RATINGS = {
  companyCulture: {
    key: 'companyCulture',
    label: 'Company culture',
  },
  compensationBenefits: {
    key: 'compensationBenefits',
    label: 'Compensation benefits',
  },
  management: {
    key: 'management',
    label: 'Management',
  },
  product: {
    key: 'product',
    label: 'Product/service',
  },
  workLifeBalance: {
    key: 'workLifeBalance',
    label: 'Work-life balance',
  },
};

export const RatingsList = ({ ratings }) => {
  return (
    <div className="ratings-list">
      {Object.values(RATINGS).map(({ key, label }) => (
        <div className="ratings-list__item" key={key}>
          <span className="ratings-list__title">{label}</span>
          <Score score={parseInt(round(ratings[key], 2).toFixed(1))} />
        </div>
      ))}
    </div>
  );
};

RatingsList.propTypes = {
  ratings: PropTypes.shape({
    companyCulture: PropTypes.number.isRequired,
    compensationBenefits: PropTypes.number.isRequired,
    management: PropTypes.number.isRequired,
    product: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    workLifeBalance: PropTypes.number.isRequired,
  }).isRequired,
};
